import { render, staticRenderFns } from "./RankingCard.vue?vue&type=template&id=fe4923f8&scoped=true"
import script from "./RankingCard.vue?vue&type=script&lang=js"
export * from "./RankingCard.vue?vue&type=script&lang=js"
import style0 from "./RankingCard.vue?vue&type=style&index=0&id=fe4923f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4923f8",
  null
  
)

export default component.exports